const TIMELINE_DRIFT_THRESHOLD_MS = 1 * 60 * 1000; // 1 minute

export const doesTimelineItemHaveLargeDrift = ({
  persistedTimestamp,
  timestamp
}) => {
  return persistedTimestamp ? Math.abs(timestamp - persistedTimestamp) > TIMELINE_DRIFT_THRESHOLD_MS : false;
};
export const getTimelineItemTimestamp = (logItem, usePersistedTimestamp = false) => {
  var _logItem$persistedTim;
  return usePersistedTimestamp ? (_logItem$persistedTim = logItem.persistedTimestamp) !== null && _logItem$persistedTim !== void 0 ? _logItem$persistedTim : logItem.timestamp : logItem.timestamp;
};
export const sortTimelineLogItems = (items, sortByPersistence) => {
  return [...items].sort((a, b) => {
    const tsA = getTimelineItemTimestamp(a, sortByPersistence);
    const tsB = getTimelineItemTimestamp(b, sortByPersistence);
    return tsB - tsA;
  });
};
export const doesSortingByProducedTsChangeOrder = items => {
  const sortedByNormalTs = sortTimelineLogItems(items, false);
  const sortedByProducedTs = sortTimelineLogItems(items, true);
  return sortedByNormalTs.some((item, index) => {
    return item !== sortedByProducedTs[index];
  });
};
export const makeTimelineItemUuid = ({
  timestamp,
  type,
  data
}) => {
  switch (type) {
    case 'PROPERTY_CHANGE':
      return `${type}-${timestamp}-${data.name}`;
    case 'FORM_SUBMISSION':
      return `${type}-${timestamp}-${data.formId}`;
    case 'LIST_MEMBERSHIP_WITH_VISIBILITY':
      return `${type}-${timestamp}-${data.objectListMembership.listId}`;
    case 'LIST_MEMBERSHIP':
      return `${type}-${timestamp}-${data.listId}`;
    case 'ASSOCIATION_CHANGE':
      return `${type}-${timestamp}-${data.association.associationTypeId}`;
    case 'ASSOCIATION_PROPERTY_CHANGE':
      return `${type}-${timestamp}-${data.objectId}-${data.property.name}`;
    case 'UNIFIED_EVENT':
      return `${type}-${timestamp}-${data.event.idempotencyId}`;
    default:
      return `${type}-${timestamp}`;
  }
};
export const makeTimelineItemHash = item => {
  return `#${makeTimelineItemUuid(item)}`;
};